const introTitle =
  "Hi, I'm Debasish. I use AI to solve the complex puzzles of Material Science.";
const introSub =
  "Currently pursuing my PhD, I spend my time teaching machines how to understand polymers. I’m fascinated by the space where Generative AI meets Materials Informatics—building the computational bridges that help us move from slow lab trials to intelligent, data-driven discovery.";

export { introTitle, introSub };
